import React from "react";
import { ModalTemplate } from "../../templates/ModalTemplate";
import { Toast } from "../../atoms/Toast";
import { useMemberEditing, useMemberPage, useMemberToast } from "../../pages/members/hook";
import { BlogForm, BlogFormData, BlogFormDataWithExistingImage } from "../form/BlogForm";
import { useBlogEditing, useBlogPage, useBlogToast } from "../../pages/blogs/hook";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onSubmit?: (data: BlogFormData) => void;
  defaultValues?: Partial<BlogFormDataWithExistingImage>;
  blogId?: string;
  refetchBlogs?: () => void;
};

export const EditBlogModal: React.FC<Props> = ({
  isOpen,
  onClose,
  onSubmit,
  defaultValues,
  blogId,
  refetchBlogs
}) => {
  const { toast, showToast, hideToast } = useBlogToast();
  const { handleEditBlog } = useBlogEditing(showToast, refetchBlogs, onClose);

  const handleFormSubmit = (data: BlogFormData, onError: (message: string) => void) => {
    if (!blogId) {
      onError('Member ID is missing.');
      return;
    }

    const apiData = {
        title: data.title,
        author_name: data.author_name,
        content: data.content,
        image: data.image,
        publish: data.publish,
      delete_image: data.delete_image
    };

    handleEditBlog(
      apiData,
      blogId,
      onError,
      () => {
        onSubmit?.(data);
      }
    );
  };

  if (!isOpen) return null;

  return (
    <div>
      {toast.visible && (
        <Toast
          message={toast.message}
          type={toast.type}
          onClose={hideToast}
        />
      )}
      <ModalTemplate
        isOpen={isOpen}
        title="Update Blog"
        onClose={onClose}
      >
        <BlogForm
          handleSubmit={handleFormSubmit}
          defaultValues={defaultValues}
          mode="edit"
          existingImageUrl={defaultValues?.existingImageUrl || null}
        />
      </ModalTemplate>
    </div>
  );
};
